<template>
    <div class="float-dialog" ref="myDialog">
      <div class="model-bg">
        <div class="dialog-bg">
          <div class="title color-dark">
              <i @click="close" style="padding:10px;float:right;cursor: pointer;" class="el-icon-close"></i>
          </div>
          <div class="float-content">
              <slot></slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapMutations } from 'vuex'

  export default {
      props:['data'],
      data(){
        return {

        }
      },
    computed: {
      // 使用对象展开运算符将 getter 混入 computed 对象中
      ...mapGetters([
        'floatzIndex',
      ])
    },
      mounted(){
        // this.setZIndex()
        // this.$refs.myDialog.style.width = this.width + 'px'
        // this.$refs.myDialog.style.height = this.height + 'px'
        // this.$refs.myDialog.style.left = (document.body.clientWidth-this.width)/2 + 'px'
      },
      methods:{
        dragendPage(e) {
          this.$refs.myDialog.style.transform = 'none'
            this.$refs.myDialog.style.top = `${e.y -  this.top }px`
            this.$refs.myDialog.style.left =`${e.x -  this.left }px`
           
        },
        dragendStart(e) {
          console.log(e);
          this.top = e.offsetY 
          this.left = e.offsetX
        },
        close(){
          this.$emit('close')
        },
        minus(){
          this.$emit('minus')
        },
        ...mapMutations([
          'addzIndex'
        ]),
      }
    }
</script>

<style lang="scss" scoped>
    .float-dialog{
      width: 800px;
       height: 60%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
        z-index: 99999;
        .model-bg {
          position: absolute;
          overflow: hidden;
          width: 800px;
          height: 100%;
          z-index:4000;
          opacity: 1;
          background: #ffffff;
        }
        .dialog-bg {
          height: 100%;
          background: linear-gradient(180deg, rgba(0,62,143,0.3) 0%, rgba(145,221,255,0) 32%, rgba(146,222,255,0) 100%);
          border-radius: 4px 4px 4px 4px;
        }
        .title{
            // height:40px;
            // padding-left:10px;
            // line-height: 40px;
        }
        .el-icon-close {
          position: absolute;
          right: 20px;
          top: 20px;
          z-index: 999;
          cursor: pointer;
        }
        .float-content{
            padding:10px;
            margin-right:3px;
            margin-left:3px;
            height:calc(100%);
            overflow: auto;
        }
    }
</style>